export var DataShapeName;
(function (DataShapeName) {
    DataShapeName["BLANK"] = "";
    // Shared base-course types
    DataShapeName["Basic"] = "Basic";
    DataShapeName["Blanks"] = "Blanks";
    DataShapeName["Default"] = "Default";
    // Math
    DataShapeName["MATH_SingleDigitAddition"] = "SingleDigitAddition";
    DataShapeName["MATH_SingleDigitSubtraction"] = "SingleDigitSubtraction";
    DataShapeName["MATH_SingleDigitDivision"] = "SingleDigitDivision";
    DataShapeName["MATH_SingleDigitMultiplication"] = "SingleDigitMultiplication";
    DataShapeName["MATH_EqualityTest"] = "EqualityTest";
    DataShapeName["MATH_OneStepEquation"] = "OneStepEquation";
    DataShapeName["MATH_AngleCategorize"] = "AngleCategorize";
    DataShapeName["MATH_SupplimentaryAngles"] = "SupplimentaryAngles";
    DataShapeName["MATH_CountBy"] = "CountBy";
    DataShapeName["MATH_NumberBond"] = "NumberBond";
    DataShapeName["MATH_BridgeTen"] = "BridgeTen";
    DataShapeName["MATH_DecadeFact"] = "DecadeFact";
    // French
    DataShapeName["FRENCH_AudioParse"] = "AudioParse";
    DataShapeName["FRENCH_Vocab"] = "Vocab";
    // WordWork
    DataShapeName["WORDWORK_Spelling"] = "WordWork_Spelling";
    // Piano
    DataShapeName["PIANO_Echo"] = "Piano_Echo";
    DataShapeName["PIANO_PlayNote"] = "Piano_PlayNote";
    // Pitch
    DataShapeName["PITCH_chroma"] = "Pitch_chroma";
    // SightSing
    DataShapeName["SIGHTSING_IdentifyKey"] = "SightSing_IdentifyKey";
    // Chess
    DataShapeName["CHESS_puzzle"] = "CHESS_puzzle";
    DataShapeName["CHESS_forks"] = "CHESS_forks";
    // Typing
    DataShapeName["TYPING_singleLetter"] = "TYPING_singleLetter";
    DataShapeName["TYPING_fallingLetters"] = "TYPING_fallingLetters";
})(DataShapeName || (DataShapeName = {}));
//# sourceMappingURL=DataShapeNames.js.map